__webpack_require__.p = "https://qa-admin.dev.dim.atea.com/";